import { render, staticRenderFns } from "./badgeGold.vue?vue&type=template&id=3c3537c0&"
import script from "./badgeGold.vue?vue&type=script&lang=js&"
export * from "./badgeGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports